export const logActiveElement = (e?: any) => {
	const target = document.activeElement;
	// console.log('ae:', textWhatever(target));
	const tag = target.tagName.toLowerCase();
	let result: any = { tag };

	const isMouse =
		(e?.pointerType && e?.pointerType === 'mouse') ||
		(e?.type && e?.type === 'click');
	const isKeyboard = e?.key && keys.includes(e?.key);

	if (e && !(isMouse || isKeyboard)) return; // Exclude
	if (['html', 'body'].includes(tag)) return; // Exclude

	if (isMouse) result.device = 'mouse';
	if (isKeyboard) {
		result.device = 'keyboard';
		result.key = e.key;
	}

	result.anvilComponent = anvilComponent(target as any);

	if (!result.anvilComponent) {
		result = { ...result, ...textWhatever(target) };
		return console.log(result);
	}

	result = { ...result, ...textWhatever(target) };
	return console.log(result);
};

function textWhatever(
	el: any,
	d = 0
): { text: string | null; textSource?: any } {
	if (!isElement(el))
		return { text: null, textSource: 'error: not an element' };

	// Case of Kendo calendar
	if (
		el.closest('.k-calendar') ||
		el.getAttribute('class')?.includes('k-calendar')
	) {
		const focused = el.querySelector(
			'.k-focus, .k-focused, .focus, .focused'
		);
		if (focused) {
			// console.log('focused', focused);
			return textWhatever(focused);
		}
	}

	const text = el.textContent.trim().slice(0, 30); // Reduce output
	if (text.length > 0) return { text, textSource: 'textContent' };

	const val = el.value ? el.value.toString() : '';
	// ?
	if (val.length > 0 && !(['on', 'off'].includes(val) && d === 0))
		return { text: val, textSource: 'value' };

	const placeholder = el.placeholder || el.getAttribute('placeholder') || '';
	if (placeholder.length > 0)
		return { text: placeholder, textSource: 'placeholder' };

	const ariaLabel = el.ariaLabel || el.getAttribute('aria-label') || '';
	if (ariaLabel.length > 0)
		return { text: ariaLabel, textSource: 'ariaLabel' };

	// look up for internal value
	const valueEl = el.querySelector('[value]');
	if (valueEl)
		return { text: valueEl.value.toString(), textSource: 'internal value' };

	const placeholderEl = el.querySelector('[placeholder]');
	if (placeholderEl)
		return {
			text: placeholderEl.placeholder,
			textSource: 'internal placeholder',
		};

	const ariaLabelEl = el.querySelector('[aria-label]');
	if (ariaLabelEl)
		return {
			text: ariaLabelEl.ariaLabel,
			textSource: 'internal ariaLabel',
		};

	// look up for external value
	let depth = d;
	const anvilEl = el.closest('[data-anvil-component]');
	if (anvilEl) {
		depth++;
		return depth < 3 && textWhatever(anvilEl, depth);
	}

	return { text: null, textSource: `not found, depth: ${depth}` };
}

const isElement = (obj: any) => {
	try {
		return obj instanceof HTMLElement || obj instanceof SVGElement;
	} catch (e) {
		return (
			typeof obj === 'object' &&
			obj.nodeType === 1 &&
			typeof obj.style === 'object' &&
			typeof obj.ownerDocument === 'object'
		);
	}
};

const anvilComponent = (el: HTMLElement) => {
	if (!isElement(el)) return null;
	const current = el.getAttribute('data-anvil-component');
	if (current) return el.getAttribute('data-anvil-component');

	const closest = el.closest('[data-anvil-component]');
	if (closest) return closest.getAttribute('data-anvil-component');

	// exeptions, elements od Anvil which could not have data-anvil-component wrapper
	const trigger = el.closest('.Trigger');
	if (trigger) return 'AnvilSelect';

	const popover = el.closest('.Popover');
	if (popover) return 'Popover';

	return false;
};

const keys = [
	'Tab',
	'Enter',
	' ',
	'ArrowUp',
	'ArrowDown',
	'ArrowLeft',
	'ArrowRight',
];
